<template>
  <div>
    <Head></Head>
    <Banner></Banner>

    <div class="container">
      <div class="info">
        <div class="lineOne"></div>
        <p class="user">用户协议</p>

        <p class="content">
          地址：安徽省合肥市蜀山区翡翠路1118号出版传媒广场10楼<br />
          乐龄听书用户协议<br /><br />

          一、协议概述<br />
          <br />
          本用户服务协议（以下简称“本协议”）是您与乐龄听书（以下简称“我们”）之间关于使用我们的服务（包括但不限于在线听书、下载图书、<br />
          参与社区讨论等）的协议。本协议旨在明确您在使用我们的服务时应当遵守的规则和注意事项。<br />
          <br />
          二、服务内容<br /><br />

          我们的服务包括但不限于以下内容：<br /><br />

          提供在线听书服务，包括但不限于各类电子书籍的在线阅读和收听；<br />
          提供下载图书服务，您可以在我们的平台上下载您感兴趣的电子书籍；<br />
          提供社区讨论功能，您可以在我们的平台上与其他用户进行学术交流和讨论；<br />
          提供其他辅助功能，如在线笔记、阅读统计等。<br /><br />
          三、用户权利和义务<br /><br />

          用户有权使用我们的服务阅读和收听电子书籍，但不得侵犯他人的合法权益；<br />
          用户应当合法使用我们的服务，不得上传、发布或传输任何违法、不良信息；<br />
          用户应当尊重他人的知识产权，不得盗版、复制或未经授权地使用他人的作品；<br />
          用户应当遵守社区规则，文明用语，不得恶意攻击他人或发布虚假信息。<br /><br />
          四、隐私保护<br /><br />

          我们尊重用户的隐私权，用户的个人信息将得到保护；<br />
          我们不会向第三方出售或共享用户的个人信息，除非得到用户的明确授权或法律规定要求；<br />
          如果您发现我们的服务存在安全漏洞或隐私泄露，请及时告知我们。<br /><br />
          五、版权声明<br /><br />

          本平台上的所有电子书籍均受版权保护，未经授权地复制、传播或使用将视为侵权行为；<br />
          如果您发现我们的服务存在版权问题，请及时告知我们。<br /><br />
          六、协议修改与终止<br /><br />

          我们保留修改本协议的权利，修改后的协议将在修改日期起生效；<br />
          如果您不同意修改后的协议，您可以选择停止使用我们的服务；<br />
          如果您违反本协议的规定，我们有权暂停或终止您的账户。<br /><br />
          七、争议解决与适用法律<br /><br />

          本协议的履行和解释均适用中华人民共和国法律；<br />
          如本协议产生任何争议，双方应首先友好协商解决；协商不成的，任何一方均有权向我们的注册地人民法院提起诉讼。<br />
        </p>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Head from './index/Head';
import Banner from './index/Banner';
import Footer from './index/Footer';

export default {
  name: 'Agreement',
  components: {
    Head,
    Banner,
    Footer,
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.lineOne {
  position: absolute;
  left: 13px;
  top: 28px;
  width: 3px;
  height: 18px;
  background-color: rgb(195, 35, 20);
}

.container {
  width: 100%;
  //    height:1000px;
  background-color: white;
  overflow: hidden;
}

.info {
  position: relative;
  width: 1200px;
  //    height:1000px;
  //    background-color: red;
  margin: 0 auto;
  overflow: hidden;
  //    background-color: red;
}

.info p.content {
  margin-left: 26px;
  font-size: 18px;
  margin-bottom: 74px;
}

.info p.user {
  font-weight: bold;
  font-size: 22px;
  // background-color: pink;
  margin-left: 26px;
}
</style>
